/** @type {import('./$types').LayoutLoad} */
export async function load() {
	return {};
}

export const prerender = true;
export const trailingSlash = 'always';
